import React from 'react';
import {connect} from "react-redux";
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
//Icon
import iconMaping from '../../../../utils/IconMaping.js';
import DetailList from '../../../../job/job_stock_check/helper/component/detail/DetailList.js';

export class JobStockDetailScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        activeTab: '1',
    }
    // Tab
    this.toggleTab = this.toggleTab.bind(this);

    this.onReadAll = this.onReadAll.bind(this);
  }

  toggleTab(tab) {
    if(this.state.activeTab !== tab) {
      this.setState({activeTab: tab});
    }
  }

  onReadAll(){
    if(this.allDetail && this.availableDetail && this.unconfirmedDetail){
      this.allDetail.onRead();
      this.availableDetail.onRead();
      this.unconfirmedDetail.onRead();
    }
  }

  render() {
    return (
      <div className="animated fadeIn">
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <Nav tabs>
              <NavItem>
                <NavLink className={classnames({ active: this.state.activeTab === '1' })} onClick={() => { this.toggleTab('1'); }} >
                  <i className={iconMaping.AVICON_JOB}></i> Unconfirmed &nbsp;
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink className={classnames({ active: this.state.activeTab === '2' })} onClick={() => { this.toggleTab('2'); }} >
                  <i className={iconMaping.AVICON_JOB}></i> Available &nbsp;
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink className={classnames({ active: this.state.activeTab === '3' })} onClick={() => { this.toggleTab('3'); }} >
                  <i className={iconMaping.AVICON_JOB}></i> All &nbsp;
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={this.state.activeTab}>

              {/* Tab 1 */}
              <TabPane tabId="1">
                <div className="card no-border">
                  <DetailList 
                    cluster={'unconfirmed'}
                    onRef={val => this.allDetail = val} 
                    onReadAll={this.onReadAll}
                    {...this.props}
                  />
                </div>
              </TabPane>

              {/*  Tab 2 */}
              <TabPane tabId="2">
                <div className="card no-border">
                  <DetailList 
                    cluster={'available'} 
                    onRef={val => this.availableDetail = val} 
                    onReadAll={this.onReadAll}
                    {...this.props}
                  />
                </div>
              </TabPane>

              {/* Tab 3 */}
              <TabPane tabId="3">
                <div className="card no-border">
                  <DetailList 
                    cluster={'all'} 
                    onRef={val => this.unconfirmedDetail = val}
                    onReadAll={this.onReadAll}
                    {...this.props}
                  />
                </div>
              </TabPane>

            </TabContent>
          </div>

        </div>
      </div>
      /*
      <div className="animated fadeIn">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-block">
                <DetailList {...this.props} />
              </div>
            </div>
          </div>
        </div>
      </div>*/
    );
  }
}

const mapStateToProps = (state) => {
  return {
    UserReducer : state.UserReducer,
  }
}

export default connect(mapStateToProps)(JobStockDetailScreen);



// WEBPACK FOOTER //
// ./src/App/views/templates/dashboard/job/job_stock_detail.js